"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reduxConnect = require("redux-connect");

var _userPickupVouchers = require("../../redux/modules/userPickupVouchers");

var _VoucherUtil = require("../../utils/VoucherUtil");

var util = _interopRequireWildcard(_VoucherUtil);

var _PickupVoucherPanel = require("../../components/print/PickupVoucherPanel");

var _PickupVoucherPanel2 = _interopRequireDefault(_PickupVoucherPanel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintableVoucher = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];

    if (!(0, _userPickupVouchers.isPickupVouchersLoaded)(getState())) {
      promises.push(dispatch((0, _userPickupVouchers.loadPickupVouchers)()));
    }

    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    vouchers: state.userPickupVouchers.vouchers
  };
}, {}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PrintableVoucher, _Component);

  function PrintableVoucher() {
    (0, _classCallCheck3.default)(this, PrintableVoucher);
    return (0, _possibleConstructorReturn3.default)(this, (PrintableVoucher.__proto__ || (0, _getPrototypeOf2.default)(PrintableVoucher)).apply(this, arguments));
  }

  (0, _createClass3.default)(PrintableVoucher, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "print-container" },
        this.renderPages()
      );
    }
  }, {
    key: "renderPages",
    value: function renderPages() {
      var _props = this.props,
          vouchers = _props.vouchers,
          params = _props.params,
          query = _props.location.query;

      var currentVoucher = util.getCurrentVoucher(vouchers, params);

      if (!currentVoucher) {
        return null;
      }

      if (typeof query.numbers === "string") {
        return _react2.default.createElement(_PickupVoucherPanel2.default, { number: query.numbers, currentVoucher: currentVoucher, query: query });
      }

      if (query.numbers && query.numbers.length) {
        var length = query.numbers.length;
        return query.numbers.map(function (number, index) {
          var style = index + 1 < length ? styles.page : {};
          return _react2.default.createElement(
            "div",
            { style: style, key: number },
            _react2.default.createElement(_PickupVoucherPanel2.default, { number: number, currentVoucher: currentVoucher, query: query })
          );
        });
      }

      return null;
    }
  }]);
  return PrintableVoucher;
}(_react.Component), _class2.propTypes = {
  vouchers: _react.PropTypes.array.isRequired,
  location: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = PrintableVoucher;


var styles = {
  page: {
    pageBreakAfter: "always"
  }
};
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Print/PrintablePickupVoucher.js
 ** module id = 1229
 ** module chunks = 0
 **/